export var MAX_UNSUCCESSFUL_LOGIN_ATTEMPTS = 5;
export var LOCKOUT_TIME_IN_MINUTES = 60;
//# sourceMappingURL=Authentication.js.map